module.exports = __webpack_public_path__ + "static/media/4.5d3e2f21.jpg";